import { Address } from "../models/address_model";
import { CartResponse } from "../models/cart_model";
import { Customer } from "../models/customer_model";
import { ItemListParams, ItemListResponse } from "../models/item_model";
import { MasterProduct } from "../models/master_product";
import { CreateOrderRequest, CreateOrderResponse, VerifyPaymentPayload } from "../models/order_model";
import { CreateRazorpayOrderResponse } from "../models/orderStatus_model";



const BASE_URL =
  "https://manthrisnonprod.azurewebsites.net";

  const reqHeaders = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  },
};

export const registerUser = async ({
  user_name,
  email_id,
  mobile_number,
}: {
  user_name: string;
  email_id: string;
  mobile_number: string;
}): Promise<{ customer: Customer | null; error?: string }> => {
  const url = "https://manthrisnonprod.azurewebsites.net/users";

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json", // ✅ correct for web
      },
      body: JSON.stringify({
        user_name,
        email_id,
        mobile_number,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      return {
        customer: {
          user_id: data.user_id,
          user_name: data.user_name,
          email: data.email || data.email_id,
          mobile_number: data.mobile_number,
          isRegistered: true,
          token: data.access_token,
          refresh_token: data.refresh_token,
        },
      };
    }

    return {
      customer: null,
      error: data?.error_message || "Registration failed",
    };
  } catch (error: any) {
    return {
      customer: null,
      error: error.message || "Something went wrong",
    };
  }
};


export const fetchHeaderProducts = async (): Promise<MasterProduct[]> => {
  try {
    const res = await fetch(`${BASE_URL}/master-product?isHeader=true`);
    if (!res.ok) {
      throw new Error(`API error: ${res.status}`);
    }
    const data = await res.json();
    return data.records || [];
  } catch (error) {
    return [];
  }
}

export const getItemList = async (params: ItemListParams = {}): Promise<ItemListResponse | undefined> => {
  const {
    page = 1,
    pageSize = 10,
    isCelebrityChoice,
    masterProductId,
    search,
    userId,
    itemId,
  } = params;

  let apiUrl = `${BASE_URL}/item?Page=${page}&PageSize=${pageSize}&IsActive=true&Status=approved`;

  if (isCelebrityChoice !== undefined) apiUrl += `&IsCelebrityChoice=${isCelebrityChoice}`;
  if (masterProductId) apiUrl += `&MasterProductId=${masterProductId}`;
  if (search?.trim()) apiUrl += `&Search=${encodeURIComponent(search)}`;
  if (userId) apiUrl += `&UserId=${userId}`;
  if (itemId) apiUrl += `&ItemId=${itemId}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: ItemListResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching item list:", error);
  }
};


export const updateItem = async (itemId: number, payload: any) => {
  try {
    const apiUrl = `${BASE_URL}/item/${itemId}`;

    const response = await fetch(apiUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

  } catch (error) {
    console.error("Error updating item:", error);
    throw error;
  }
};

export const addToWishlist = async (userId: string | number, itemId: string | number) => {
  try {
    const response = await fetch(`${BASE_URL}/users/${userId}/wishlist`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      body: JSON.stringify({ item_id: itemId }),
    });
    const data = await response.json();
    return data;
  } catch (error: any) {
    throw error;
  }
};



export const getCartItems = async (
): Promise<CartResponse | null> => {
  try {
        const userId = localStorage.getItem("userId");

    if (!userId) return null;

    const response = await fetch(`${BASE_URL}/users/${userId}/cart`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Include auth header if needed
        // Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      return null;
    }

    const data: CartResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch cart items", error);
    return null;
  }
};


export type { ItemListParams };


export const updateCartItem = async (
  cartId: number,
  itemId: number,
  item_count: number
) => {
  try {
    const userId = localStorage.getItem("userId");

    const res = await fetch(`${BASE_URL}/users/${userId}/cart/${cartId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        item_id: itemId,
        item_count: item_count,
      }),
    });

    if (!res.ok) {
      throw new Error(`Failed to update cart item: ${res.status}`);
    }

    return await res.json();
  } catch (error) {
    console.error("Error updating cart item:", error);
    return null;
  }
};

export const removeCartItem = async (
  userId: string | number,
  cartId: number
) => {
  try {
    const res = await fetch(`${BASE_URL}/users/${userId}/cart/${cartId}`, {
      method: "DELETE",
    });

    return res.status === 204;
  } catch (error) {
    console.error("Error removing cart item:", error);
    return false;
  }
};

export const addToCartItem = async (
  item_id: number | undefined,
  item_count: number | undefined,
  is_replace_cart?: boolean
) => {
  const userId = localStorage.getItem("userId");
  if (!userId) return;
  if (!item_id || item_id <= 0) return;
  if (!item_count || item_count <= 0) return;

  try {
    const body: Record<string, any> = {
      item_id,
      item_count,
    };

    if (is_replace_cart !== undefined) {
      body.is_replace_cart = is_replace_cart;
    }

    const res = await fetch(`${BASE_URL}/users/${userId}/cart`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw new Error(`Failed to add to cart: ${res.status}`);
    }

    return await res.json();
  } catch (err) {
    console.error("Error adding to cart:", err);
    return null;
  }
};

export const getUser = async (mobileNumber: string) => {
  const url = `${BASE_URL}/users/${mobileNumber}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (response.ok) {
      if (data.is_new_user) {
        return { status: "new_user", message: data.message };
      }

      if (data.user_id) {
        return {
          token: data.access_token,
          user_id: data.user_id,
          refresh_token: data.refresh_token,
          user_name: data.user_name,
          email: data.email,
          mobile_number: data.mobile_number,
          isRegistered: true,
        };
      }
    }

    return { status: "invalid", message: data?.message || response.statusText };
  } catch (error: any) {
    return { status: "invalid", message: error?.message || "Invalid OTP" };
  }
};

export const getAddressList = async (userId: string | number): Promise<Address[]> => {
  try {
    const res = await fetch(`${BASE_URL}/users/${userId}/address`, reqHeaders);
    if (!res.ok) throw new Error("Failed to fetch addresses");
    return res.json();
  } catch (error) {
    console.error(error);
    return [];
  }
};

// Remove an address
export const removeAddress = async (userId: string | number, addressId: string | number): Promise<boolean> => {
  try {
    const res = await fetch(`${BASE_URL}/users/${userId}/address/${addressId}`, {
      ...reqHeaders,
      method: "DELETE",
    });
    return res.status === 204;
  } catch (error) {
    console.error("Failed to delete address:", error);
    return false;
  }
};

// Add a new address
export const addAddress = async (userId: string | number, address: Address): Promise<boolean> => {
  try {
    const res = await fetch(`${BASE_URL}/users/${userId}/address`, {
      ...reqHeaders,
      method: "POST",
      headers: {
        ...reqHeaders.headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(address),
    });
    return res.status === 201;
  } catch (error) {
    console.error("Failed to add address:", error);
    return false;
  }
};

// Update an existing address
export const updateAddress = async (userId: string | number, address: Address): Promise<boolean> => {
  if (!address.address_id) {
    console.error("Address ID is required for update");
    return false;
  }

  try {
    const res = await fetch(`${BASE_URL}/users/${userId}/address/${address.address_id}`, {
      ...reqHeaders,
      method: "PUT",
      headers: {
        ...reqHeaders.headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(address),
    });
    return res.status === 204;
  } catch (error) {
    console.error("Failed to update address:", error);
    return false;
  }
};

export async function createUserOrderSafe(
  userId: string | number,
  orderData: CreateOrderRequest
): Promise<{ orderId: string; phonePeOrderId: string; phone_pe_redirect_url: string } | null> {
  try {
    const response = await fetch(`${BASE_URL}/users/${userId}/order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(orderData),
    });

    if (!response.ok) {
      console.error("Failed to create order:", response.status, response.statusText);
      return null;
    }

    const data: CreateOrderResponse = await response.json();

    if (data?.phone_pe_order_id && data?.phone_pe_redirect_url) {
      return {
        orderId: data.order_number ?? "",
        phonePeOrderId: data.phone_pe_order_id,
        phone_pe_redirect_url: data.phone_pe_redirect_url,
      };
    }

    return null;
  } catch (err) {
    console.error("Error creating order:", err);
    return null;
  }
}


export async function getUserFromId(userId: number | string): Promise<Customer | null> {
  try {
    const res = await fetch(`${BASE_URL}/users?UserId=${userId}`, {
      headers: { accept: "text/plain" },
    });

    if (!res.ok) {
      console.error("Failed to fetch user, status:", res.status);
      return null;
    }

    const data = await res.json();

    const user = data.records?.[0];
    if (!user) return null;

    const customer: Customer = {
      user_id: user.user_id,
      user_name: user.user_name,
      email: user.email_id,
      mobile_number: user.mobile_number,
      isRegistered: true,
    };

    return customer;
  } catch (err) {
    return null;
  }
}

export async function createUserOrder(
  userId: string | number,
  orderData: CreateOrderRequest
): Promise<CreateRazorpayOrderResponse | null> {
  try {
    const response = await fetch(`${BASE_URL}/users/${userId}/order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(orderData),
    });

    if (!response.ok) return null;

    return await response.json();
  } catch (err) {
    console.error(err);
    return null;
  }
}


export const verifyRazorpayPayment = async (
  orderId: number,
  payload: VerifyPaymentPayload
) => {
  return fetch(
    `${BASE_URL}/users/orders/${orderId}/verify-razorpay-payment`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    }
  );
};